import { gql } from '@apollo/client';

export const FULL_CHANNEL = gql`
    fragment FullChannel on DeliveryNoteProcessingChannelType {
        id
        name
        team {
            id
            name
        }
        emailAddress
        timePerDocumentBeforeWorkist

        xmlSerializerConfig {
            enabled
            serializerModule
            headerFields
            lineItemFields
            exportExternalDocumentLink
            exportReceivedBy
            exportWorkistUrl
            useShortExternalFileName
        }

        emailConfig {
            enabled
            inboxName
            allowSentByMatchByName
            enableEmailOnlyDocumentProcessing
        }

        masterDataConfig {
            authToken

            clientLookupDefinitionId
            receiverLookupDefinitionId
            contactLookupDefinitionId
            clientInternalContactLookupDefinitionId
            emailLookupDefinitionId

            articleLookupDefinitionId
            debitorArticleLookupDefinitionId
            conversionFactorLookupDefinitionId
            frameworkContractLookupDefinitionId

            invoiceAddressLookupDefinitionId
            deliveryAddressLookupDefinitionId
            clientMappingLookupDefinitionId
            contactMappingLookupDefinitionId

            articleMappingLookupDefinitionId
            vatIdCheckMappingLookupDefinitionId

            invoiceAddressMappingLookupDefinitionId
            deliveryAddressMappingLookupDefinitionId
        }

        sftpConfig {
            sftpHost
            sftpHostKey
            sftpPort
            sftpUser
        }

        as2Config {
            senderAs2Name
            receiverUrl
            receiverAs2Name
            receiverVerifyCert
            receiverEncryptCert
            verifyReceiverCertificates
        }

        uploadConfig {
            enabled
            targetPathFileExport
            targetPathOriginalDocument
            sendOriginalDocument
            sendOriginalEmail
            deliveryMethod
        }

        documentConfig {
            options {
                name
                value
                valueType
                defaultValue
            }

            fields {
                name
                valueType
                position
                enabled
                options {
                    name
                    value
                    valueType
                    defaultValue
                    configurable
                }
            }

            timezoneOptions
            holidayCalendarCodeOptions
        }

        discardConfig {
            forwardingAddresses
            sendBack
        }
    }
`;

export const CREATE_CONFIG = gql`
    mutation ($channelId: UUID!, $configName: String!) {
        createDeliveryNoteProcessingChannelConfig(channelId: $channelId, configName: $configName) {
            success
        }
    }
`;

export const DELETE_CONFIG = gql`
    mutation ($channelId: UUID!, $configName: String!) {
        deleteDeliveryNoteProcessingChannelConfig(channelId: $channelId, configName: $configName) {
            success
        }
    }
`;

export const GET_CHANNEL_CONFIG = gql`
    ${FULL_CHANNEL}
    query ($id: UUID!) {
        deliveryNoteProcessingChannel(id: $id) {
            ...FullChannel
        }
    }
`;

export const UPDATE_CHANNEL = gql`
    mutation (
        $channelId: UUID!
        $name: String
        $teamId: UUID
        $emailConfig: UpdateEmailConfigInput
        $masterDataConfig: UpdateMasterDataConfigInput
        $xmlSerializerConfig: UpdateXMLSerializerConfigInput
        $sftpConfig: UpdateSFTPConfigInput
        $as2Config: UpdateAS2ConfigInput
        $uploadConfig: UpdateUploadConfigInput
        $discardConfig: UpdateDiscardConfigInput
        $timePerDocumentBeforeWorkist: Int
    ) {
        updateDeliveryNoteProcessingChannel(
            channelId: $channelId
            name: $name
            teamId: $teamId
            emailConfig: $emailConfig
            masterDataConfig: $masterDataConfig
            xmlSerializerConfig: $xmlSerializerConfig
            sftpConfig: $sftpConfig
            as2Config: $as2Config
            uploadConfig: $uploadConfig
            discardConfig: $discardConfig
            timePerDocumentBeforeWorkist: $timePerDocumentBeforeWorkist
        ) {
            success
        }
    }
`;

export const DELETE_MAPPINGS = gql`
    mutation ($channelId: UUID!, $beforeDate: Date!, $mappingType: String!) {
        deliveryNoteChannelDeleteMappings(channelId: $channelId, beforeDate: $beforeDate, mappingType: $mappingType) {
            deletedCount
            success
        }
    }
`;

export const EXPORT_CONFIGS = gql`
    mutation ($channelId: UUID!, $configNames: [String]!) {
        deliveryNoteExportConfigs(channelId: $channelId, configNames: $configNames) {
            data
            success
        }
    }
`;

export const IMPORT_CONFIGS = gql`
    mutation ($channelId: UUID!, $file: Upload!) {
        deliveryNoteImportConfigs(channelId: $channelId, file: $file) {
            success
        }
    }
`;
